import CheckCircle2 from 'lucide-react/dist/esm/icons/check-circle-2'
import ShieldCheck from 'lucide-react/dist/esm/icons/shield-check'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogCloseButton,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from '@/components/ui/dialog'

interface VerificationCompleteDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

/** Shown when the client completes every required verification step in the current session. */
export function VerificationCompleteDialog({ open, onOpenChange }: VerificationCompleteDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="gap-0 overflow-hidden p-0 sm:max-w-[420px]">
        <DialogCloseButton className="right-3.5 top-3.5" />

        <div className="flex flex-col items-center px-6 pb-4 pt-8 text-center">
          <div
            className="mb-5 flex h-12 w-12 items-center justify-center rounded-2xl bg-success/15 ring-1 ring-inset ring-success-border/25"
            aria-hidden="true"
          >
            <CheckCircle2 className="h-6 w-6 text-success-border" strokeWidth={2} />
          </div>

          <DialogTitle className="text-lg font-semibold tracking-tight">
            Submission complete
          </DialogTitle>
          <DialogDescription className="mt-2 max-w-[19rem] text-sm leading-relaxed">
            Thank you for completing your submission. The Mezza risk team will review it and
            contact you if anything else is needed.
          </DialogDescription>
        </div>

        <div className="mx-6 mb-2 mt-2 rounded-xl border border-border/60 bg-muted/20 px-4 py-3.5 text-left">
          <div className="flex items-start gap-3">
            <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-success-border" aria-hidden="true" />
            <p className="text-xs leading-relaxed text-muted-foreground">
              Your files are secure and only our risk team can access them. You can close this page
              - nothing else is needed right now.
            </p>
          </div>
        </div>

        <DialogFooter className="mt-4 border-t border-border/40 px-6 py-5 sm:justify-center">
          <Button
            type="button"
            className="h-11 w-full rounded-xl sm:max-w-[200px]"
            onClick={() => onOpenChange(false)}
          >
            Got it
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
